import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { AdminSubjectClassifierService } from '../../services/admin/admin-subjectclassifier.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, EmailType } from '../../global/constants';

@Component({
  selector: 'app-admin-subject-classifier',
  templateUrl: './admin-subject-classifier.component.html'
})
export class AdminSubjectClassifierComponent implements OnInit {
  loadingPage = true;
  addTrainingDialogRef: BsModalRef;

  currentType: EmailType;
  training: any[] = [];

  localEmailTypes: EmailType[];

  newTraining: any = {
    category: '',
    content: '',
    human: false,
    language: 'en',
    override: false
  };

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private adminSubjectClassifierService: AdminSubjectClassifierService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.currentType = this.constants.emailTypes[1];
    this.localEmailTypes = JSON.parse(JSON.stringify(this.constants.emailTypes));
    this.localEmailTypes.push(new EmailType('x', 'n/a', false, false, true, false, false, false, 'Empty type', ''));
    this.refreshTraining();
  }

  changeType(type: EmailType) {
    this.currentType = type;
    this.refreshTraining();
  }

  addTraining(dialog, training: any = null) {
    this.newTraining.category = this.currentType.typeName;
    this.addTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-lg'});
  }

  saveTraining() {
    this.addTrainingDialogRef.hide();
    this.adminSubjectClassifierService.newSubjectTraining(this.newTraining).subscribe(
      (result: any) => {
        this.globalMessageService.message('Added training');
        this.newTraining ={
          category: '',
          content: '',
          human: false,
          language: 'en',
          override: false
        };
        this.refreshTraining();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-subject-classifier.component', 'editTraining.200');
      }
    );
  }

  deleteTraining(training: any) {
    this.adminSubjectClassifierService.deleteSubjectTraining(training._id).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training deleted');
        this.refreshTraining();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-subject-classifier.component', 'deleteTraining.100');
      }
    )
  }

  private refreshTraining() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.adminSubjectClassifierService.getSubjectTraining(this.currentType.typeName)
    ).subscribe(
      (result: any) => {
        this.training = result[0];
        this.training.forEach((d) => {
          d.lang = this.constants.languages.find((l) => {return l.name==d.language}).display;
        });
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-subject-classifier.component', 'refreshTraining.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-subject-classifier/admin-subject-classifier.component.ts